// @flow

import type { Action } from './store.type';

export const GET_CUSTOM_RANGE_SLIDERS_REQUEST = 'GET_CUSTOM_RANGE_SLIDERS_REQUEST';
type GET_CUSTOM_RANGE_SLIDERS_REQUEST_TYPE = 'GET_CUSTOM_RANGE_SLIDERS_REQUEST';

export const GET_CUSTOM_RANGE_SLIDERS_SUCCESS = 'GET_CUSTOM_RANGE_SLIDERS_SUCCESS';
type GET_CUSTOM_RANGE_SLIDERS_SUCCESS_TYPE = 'GET_CUSTOM_RANGE_SLIDERS_SUCCESS';

export const GET_CUSTOM_RANGE_SLIDERS_FAILURE = 'GET_CUSTOM_RANGE_SLIDERS_FAILURE';
type GET_CUSTOM_RANGE_SLIDERS_FAILURE_TYPE = 'GET_CUSTOM_RANGE_SLIDERS_FAILURE';

type CustomRangeSliderType = {
  namespace: string,
  key: string,
  appliesTo: Object,
  type: string
};

type GetCustomRangeSlidersSuccess = {
  data: Array<CustomRangeSliderType>,
  total: number
};

type GetCustomRangeSliderFailure = {
  error: any
};

type GetCustomRangeSlidersRequestAction = Action<GET_CUSTOM_RANGE_SLIDERS_REQUEST_TYPE, null>;

type GetCustomRangeSlidersSuccessAction = Action<
  GET_CUSTOM_RANGE_SLIDERS_SUCCESS_TYPE,
  GetCustomRangeSlidersSuccess
>;

type GetCustomRangeSlidersFailureAction = Action<
  GET_CUSTOM_RANGE_SLIDERS_FAILURE_TYPE,
  GetCustomRangeSliderFailure
>;

// Create custom range slider
export const CREATE_CUSTOM_RANGE_SLIDER_REQUEST = 'CREATE_CUSTOM_RANGE_SLIDER_REQUEST';
type CREATE_CUSTOM_RANGE_SLIDER_REQUEST_TYPE = 'CREATE_CUSTOM_RANGE_SLIDER_REQUEST';

export const CREATE_CUSTOM_RANGE_SLIDER_SUCCESS = 'CREATE_CUSTOM_RANGE_SLIDER_SUCCESS';
type CREATE_CUSTOM_RANGE_SLIDER_SUCCESS_TYPE = 'CREATE_CUSTOM_RANGE_SLIDER_SUCCESS';

export const CREATE_CUSTOM_RANGE_SLIDER_FAILURE = 'CREATE_CUSTOM_RANGE_SLIDER_FAILURE';
type CREATE_CUSTOM_RANGE_SLIDER_FAILURE_TYPE = 'CREATE_CUSTOM_RANGE_SLIDER_FAILURE';

type CreateCustomRangeSliderRequestAction = Action<CREATE_CUSTOM_RANGE_SLIDER_REQUEST_TYPE, null>;

type CreateCustomRangeSliderSuccessAction = Action<
  CREATE_CUSTOM_RANGE_SLIDER_SUCCESS_TYPE,
  CreateCustomRangeSliderSuccess
>;

type CreateCustomRangeSliderFailureAction = Action<
  CREATE_CUSTOM_RANGE_SLIDER_FAILURE_TYPE,
  CreateCustomRangeSliderFailure
>;

// Delete custom range slider
export const DELETE_CUSTOM_RANGE_SLIDER_REQUEST = 'DELETE_CUSTOM_RANGE_SLIDER_REQUEST';
type DELETE_CUSTOM_RANGE_SLIDER_REQUEST_TYPE = 'DELETE_CUSTOM_RANGE_SLIDER_REQUEST';

export const DELETE_CUSTOM_RANGE_SLIDER_SUCCESS = 'DELETE_CUSTOM_RANGE_SLIDER_SUCCESS';
type DELETE_CUSTOM_RANGE_SLIDER_SUCCESS_TYPE = 'DELETE_CUSTOM_RANGE_SLIDER_SUCCESS';

export const DELETE_CUSTOM_RANGE_SLIDER_FAILURE = 'DELETE_CUSTOM_RANGE_SLIDER_FAILURE';
type DELETE_CUSTOM_RANGE_SLIDER_FAILURE_TYPE = 'DELETE_CUSTOM_RANGE_SLIDER_FAILURE';

type DeleteCustomRangeSliderRequestAction = Action<DELETE_CUSTOM_RANGE_SLIDER_REQUEST_TYPE, null>;

type DeleteCustomRangeSliderSuccessAction = Action<
  DELETE_CUSTOM_RANGE_SLIDER_SUCCESS_TYPE,
  DeleteCustomRangeSliderSuccess
>;

type DeleteCustomRangeSliderFailureAction = Action<
  DELETE_CUSTOM_RANGE_SLIDER_FAILURE_TYPE,
  DeleteMerchandisingFailure
>;

// Update custom range slider
export const UPDATE_CUSTOM_RANGE_SLIDER_REQUEST = 'UPDATE_CUSTOM_RANGE_SLIDER_REQUEST';
type UPDATE_CUSTOM_RANGE_SLIDER_REQUEST_TYPE = 'UPDATE_CUSTOM_RANGE_SLIDER_REQUEST';

export const UPDATE_CUSTOM_RANGE_SLIDER_SUCCESS = 'UPDATE_CUSTOM_RANGE_SLIDER_SUCCESS';
type UPDATE_CUSTOM_RANGE_SLIDER_SUCCESS_TYPE = 'UPDATE_CUSTOM_RANGE_SLIDER_SUCCESS';

export const UPDATE_CUSTOM_RANGE_SLIDER_FAILURE = 'UPDATE_CUSTOM_RANGE_SLIDER_FAILURE';
type UPDATE_CUSTOM_RANGE_SLIDER_FAILURE_TYPE = 'UPDATE_CUSTOM_RANGE_SLIDER_FAILURE';

type UpdateCustomRangeSliderRequestAction = Action<UPDATE_CUSTOM_RANGE_SLIDER_REQUEST_TYPE, null>;

type UpdateCustomRangeSliderSuccessAction = Action<
  UPDATE_CUSTOM_RANGE_SLIDER_SUCCESS_TYPE,
  UpdateCustomRangeSliderSuccess
>;

type UpdateCustomRangeSliderFailureAction = Action<
  UPDATE_CUSTOM_RANGE_SLIDER_FAILURE_TYPE,
  UpdateCustomRangeSliderFailure
>;

// Action and State
export type CustomRangeSliderAction =
  | GetCustomRangeSlidersRequestAction
  | GetCustomRangeSlidersSuccessAction
  | GetCustomRangeSlidersFailureAction
  | CreateCustomRangeSliderRequestAction
  | CreateCustomRangeSliderSuccessAction
  | CreateCustomRangeSliderFailureAction
  | DeleteCustomRangeSliderRequestAction
  | DeleteCustomRangeSliderSuccessAction
  | DeleteCustomRangeSliderFailureAction
  | UpdateCustomRangeSliderRequestAction
  | UpdateCustomRangeSliderSuccessAction
  | UpdateCustomRangeSliderFailureAction;

export type CustomRangeSliderState = {
  loading: boolean,
  saving: boolean,
  deleting: boolean,
  reordering: boolean,
  scheduleSyncIn: number,
  scheduleSyncAfter: number,
  waitSyncAt: number,

  success: boolean,
  error: null,
  customRangeSliders: Array<CustomRangeSliderType>,
  total: number
};
